// Magyar szövegek az Outfino Creator Portálhoz.
const hu = {
  // ---- Nav ----
  'nav.how': 'Hogyan működik',
  'nav.more': 'Több mint együttműködés',
  'nav.who': 'Kinek szól',
  'nav.dashboard': 'Vezérlőpult',
  'nav.login': 'Belépés',

  // ---- Hero ----
  'hero.badge': 'Outfino Creator program',
  'hero.title': 'Legyél Outfino Creator',
  'hero.tagline': 'Készíts tartalmat. Építs közösséget. Keress vele.',
  'hero.subtitle':
    'Videók az Outfinónak - teljesítményalapú díjazással és ingyenes Circle tagsággal.',
  'hero.ctaLogin': 'Belépés az Outfino fiókba',
  'hero.ctaLearn': 'Hogyan működik?',

  // ---- How it works ----
  'how.eyebrow': 'Hogyan működik?',
  'how.title': 'A jelentkezéstől az első fizetett videódig',
  'how.1.title': 'Jelentkezz be',
  'how.1.body': 'A Creator profilod az Outfino fiókodhoz kapcsolódik.',
  'how.2.title': 'Jelentkezz Creatornek',
  'how.2.body': 'Add meg a TikTok vagy Instagram profilod. Min. 10 000 követő kell.',
  'how.3.title': 'Kapj briefeket',
  'how.3.body': 'Elfogadás után briefeket kapsz - az elvárásokkal és a határidővel.',
  'how.4.title': 'Készítsd el a videót',
  'how.4.body': 'Töltsd fel review-ra a portálon. A visszajelzést is itt kapod.',
  'how.5.title': 'Publikáld és keress vele',
  'how.5.body':
    'Jóváhagyás után publikáld. A díjazás videónként, teljesítmény szerint - havonta, minden hónap 10-éig.',

  // ---- How it works modal (dashboard tutorial) ----
  'how.modalTitle': 'Hogyan működik?',
  'how.modalLead':
    'Így néz ki a teljes folyamat a jelentkezéstől a kifizetésig.',
  'how.close': 'Bezárás',
  'how.gotIt': 'Értem',
  'how.step.apply.title': 'Jelentkezel egy briefre',
  'how.step.apply.body':
    'A Briefek fülön a nyitott briefeknél a jelentkezési határidőig tudsz jelentkezni egyetlen gombbal. Ekkor még nem kell videót készítened.',
  'how.step.select.title': 'Kiválasztunk',
  'how.step.select.body':
    'A jelentkezők közül profil, korábbi teljesítmény, stílus és közönség alapján választunk ki néhány creatort. Csak a kiválasztottak kapják meg a "Kiválasztva" státuszt és a leadási határidőt.',
  'how.step.brief.title': 'Megkapod a részleteket',
  'how.step.brief.body':
    'A kiválasztott briefnél előre látod a tartalmi elvárásokat, a leadási határidőt és a díjazás feltételeit. Innen már el is kezdheted a munkát.',
  'how.step.create.title': 'Elkészíted és feltöltöd',
  'how.step.create.body':
    'Készítsd el a videó(ka)t a brief alapján, és töltsd fel őket a hozzájuk tartozó feltöltő négyzetekbe, majd küldd be review-ra.',
  'how.step.review.title': 'Review és visszajelzés',
  'how.step.review.body':
    'Átnézzük a beküldött tartalmat. Ha módosítás kell, itt a portálon kapod meg a visszajelzést. Jóváhagyás után mehet a következő lépés.',
  'how.step.publish.title': 'Publikálás',
  'how.step.publish.body':
    'A jóváhagyott videót publikálod a megadott platformon (TikTok vagy Instagram), a brief feltételei szerint.',
  'how.step.payout.title': 'Kifizetés',
  'how.step.payout.body':
    'A díjazás videónként, a tartalom teljesítménye alapján történik. A kifizetéseket havonta, minden hónap 10. napjáig utaljuk. Az egyenleged és az előzményeid a Kifizetések fülön látod.',

  // ---- More than a collaboration ----
  'more.eyebrow': 'Több mint egy együttműködés',
  'more.title': 'Alakítsd velünk, hogyan fedezi fel a divatot a következő generáció.',
  'more.paid.title': 'Fizetett együttműködések',
  'more.paid.body': 'Minden briefnél előre tudod, mit várunk és milyen feltételekkel.',
  'more.perf.title': 'Teljesítményalapú díjazás',
  'more.perf.body':
    'A díjazás a kampány feltételei és a teljesítmény szerint, havonta minden hónap 10-éig.',
  'more.circle.title': 'Ingyenes Circle tagság',
  'more.circle.body': 'Aktív Creatorként ingyenes Outfino Circle tagságot kapsz.',
  'more.place.title': 'Minden egy helyen',
  'more.place.body': 'Briefek, beküldés, review és státusz - mind a portálon.',

  // ---- Who can apply ----
  'who.eyebrow': 'Kinek szól a Creator Program?',
  'who.title': 'Akkor jelentkezz, ha:',
  'who.1': 'legalább 10 000 követőd van TikTokon vagy Instagramon;',
  'who.2': 'divat-, outfit- vagy lifestyle-tartalmat készítesz;',
  'who.3': 'szívesen dolgoznál rendszeres videós kampányokon;',
  'who.4': 'brief alapján is a saját stílusodban alkotsz.',
  'who.highlight':
    'Külön szívesen dolgozunk olyanokkal, akik maguk is aktívan használják az Outfinót - így a tartalom is hitelesebb lesz.',
  'who.note':
    'Nem reklámvideókat keresünk - hiteles creatoröket, akik a saját közösségüknek mutatják be az Outfinót.',

  // ---- CTA ----
  'cta.title': 'Csatlakoznál?',
  'cta.body': 'Jelentkezz be az Outfino fiókodba, majd add le Creator jelentkezésedet.',
  'cta.apply': 'Belépés és jelentkezés',
  'cta.note': 'Minimum 10 000 követő szükséges TikTokon vagy Instagramon.',

  // ---- Footer ----
  'footer.tagline':
    'Készíts tartalmat az Outfinónak, és keress a videóid teljesítményével.',
  'footer.product': 'Program',
  'footer.company': 'Cég',
  'footer.legal': 'Jogi',
  'footer.privacy': 'Adatvédelem',
  'footer.terms': 'Feltételek',
  'footer.rights': 'Minden jog fenntartva.',

  // ---- Login ----
  'login.back': 'Vissza a főoldalra',
  'login.title': 'Creator Portál',
  'login.subtitle': 'Jelentkezz be a jelentkezéshez és az együttműködéseid kezeléséhez.',
  'login.email': 'E-mail cím',
  'login.password': 'Jelszó',
  'login.submit': 'Belépés',
  'login.loading': 'Bejelentkezés…',
  'login.wrongCredentials': 'Hibás e-mail vagy jelszó.',
  'login.networkError': 'Hálózati hiba. Próbáld újra.',
  'login.notice': 'Jelentkezz be az Outfino fiókoddal.',
  'login.google': 'Bejelentkezés Google-lel',
  'login.apple': 'Bejelentkezés Apple-lel',
  'login.or': 'vagy',
  'login.googleFailed': 'Google bejelentkezés sikertelen.',
  'login.googleCloseWindow': 'Bejelentkezve. Ezt az ablakot bezárhatod.',
  'login.appleUnavailable': 'Apple bejelentkezés nem elérhető.',
  'login.appleFailed': 'Apple bejelentkezés sikertelen.',

  // ---- Dashboard shell ----
  'shell.logout': 'Kijelentkezés',
  'shell.loading': 'Betöltés…',
  'shell.refresh': 'Frissítés',
  'shell.newCount': '{count} új',
  'sidebar.expand': 'Kinyitás',
  'sidebar.collapse': 'Összecsukás',
  'sidebar.menu': 'Menü',
  'sidebar.menuClose': 'Menü bezárása',
  'theme.light': 'Világos',
  'theme.dark': 'Sötét',
  'theme.lightTitle': 'Világos téma',
  'theme.darkTitle': 'Sötét téma',
  'lang.name': 'Magyar',
  'lang.switchTitle': 'Angolra váltás',
  'shell.error': 'Valami hiba történt. Frissítsd az oldalt, vagy próbáld újra.',
  'shell.retry': 'Újra',

  // ---- Application form (not a creator yet) ----
  'apply.title': 'Jelentkezz Outfino Creatornek',
  'apply.subtitle':
    'Add meg a TikTok vagy Instagram profilod - legalább az egyik kötelező.',
  'apply.req': 'Minimum 10 000 követő szükséges TikTokon vagy Instagramon. Legalább az egyik profilt add meg; a többi mező kötelező.',
  'apply.tiktok': 'TikTok profil',
  'apply.tiktokPlaceholder': '@felhasznalonev vagy https://tiktok.com/@felhasznalonev',
  'apply.instagram': 'Instagram profil',
  'apply.instagramPlaceholder': '@felhasznalonev vagy https://instagram.com/felhasznalonev',
  'apply.note': 'Rövid bemutatkozás',
  'apply.notePlaceholder':
    'Mesélj a tartalmaidról, a közösségedről és arról, miért szeretnél az Outfinónak készíteni…',
  'apply.submit': 'Jelentkezés elküldése',
  'apply.submitting': 'Küldés…',
  'apply.needAll': 'Küldés előtt tölts ki minden mezőt, és fogadd el mindkét nyilatkozatot.',
  'apply.errSocial': 'Add meg legalább az egyik profilod (TikTok vagy Instagram).',
  'apply.errTiktok': 'Add meg a TikTok profilod.',
  'apply.errInstagram': 'Add meg az Instagram profilod.',
  'apply.errNote': 'Írj pár sort magadról.',
  // #597 — a két nyilatkozat. Az ÁSZF szövege a mondat közepén hivatkozás,
  // ezért van három darabban: előtag + link + utótag.
  'apply.termsBefore': 'Elfogadom az',
  'apply.termsLink': 'Általános Szerződési Feltételeket',
  'apply.termsAfter': '.',
  'apply.followersDeclaration':
    'Kijelentem, hogy legalább az egyik platformon (TikTok vagy Instagram) legalább 10 000 követőm van.',
  'apply.errTerms': 'Az ÁSZF elfogadása kötelező.',
  'apply.errFollowers': 'A követőszámra vonatkozó nyilatkozat kötelező.',
  'apply.pendingTitle': 'Jelentkezésed elküldve',
  'apply.pendingBody':
    'Köszönjük - a jelentkezésed elbírálás alatt. Jóváhagyás után itt jelennek meg a briefjeid és kifizetéseid.',
  'apply.pendingBadge': 'Elbírálás alatt',
  'apply.error': 'A jelentkezés elküldése nem sikerult. Próbáld újra.',

  // ---- Creator dashboard ----
  'creator.greeting': 'A Creator Portálod',
  'tab.tasks': 'Feladatok',
  'tab.briefs': 'Briefek',
  'tab.payouts': 'Kifizetések',
  'tab.application': 'Jelentkezés',

  // ---- Tasks (deadlines + countdowns) ----
  'tasks.empty': 'Még nincs feladatod. Ha kiválasztanak egy briefre, itt jelenik meg.',
  'tasks.activeHeading': 'Leadásra vár',
  'tasks.reviewHeading': 'Review alatt',
  'tasks.browseBriefs': 'Nyitott briefek',
  'tasks.pastHeading': 'Előzmények',
  'tasks.reviewTitle': 'Beküldted a videókat',
  'tasks.reviewBody': 'Átnézzük őket, és itt kapsz visszajelzést.',
  'tasks.approvedTitle': 'Jóváhagytuk a videóidat',
  'tasks.approvedBody': 'A díjazásodat a Kifizetések fülön látod.',
  'tasks.notApprovedTitle': 'Az értékelés lezárult',
  'tasks.notApprovedBody': 'Nem minden videód lett jóváhagyva. Lent látod a visszajelzést videónként.',
  'tasks.resultsTitle': 'Eredmények',
  'tasks.resultsSummary': '{approved}/{total} videó jóváhagyva',
  'tasks.videoN': '{n}. videó',
  'tasks.reviewNote': 'Visszajelzés',
  'tasks.result.submitted': 'Elbírálásra vár',
  'tasks.result.approved': 'Jóváhagyva',
  'tasks.result.rejected': 'Elutasítva',
  'tasks.earning.pending': 'kifizetésre vár',
  'tasks.earning.processing': 'folyamatban',
  'tasks.earning.completed': 'kifizetve',
  'tasks.earning.failed': 'sikertelen kifizetés',
  'tasks.earning.cancelled': 'visszavonva',
  'tasks.deliveryIn': 'Leadásig hátra',
  'tasks.deadlinePassed': 'Lejárt',
  'tasks.d': 'nap',
  'tasks.h': 'ó',
  'tasks.m': 'p',
  'tasks.s': 'mp',

  // ---- Briefs ----
  'briefs.title': 'Videós briefek',
  'briefs.subtitle':
    'Az elérhető együttműködéseid. Töltsd fel a videóidat review-ra.',
  'briefs.empty': 'Jelenleg nincs elérhető brief. Nézz vissza hamarosan.',
  'briefs.group.open': 'Nyitott',
  'briefs.group.applied': 'Jelentkeztél',
  'briefs.group.not_selected': 'Nem lettél kiválasztva',
  'briefs.deadline': 'Határidő',
  'briefs.payment': 'Díjazás',
  'briefs.perVideo': '{amount} / videó',
  'briefs.required': '{count} videó',
  'briefs.required_plural': '{count} videó',
  'briefs.uploaded': '{done} / {total} feltöltve',
  'briefs.more': 'Tovább',
  'briefs.less': 'Kevesebb',
  'briefs.slotHint': 'Videó hozzáadása',
  'briefs.slotAny': 'MP4, MOV, WebM…',
  'briefs.remove': 'Videó eltávolítása',
  'briefs.submit': 'Beküldés review-ra',
  'briefs.submitting': 'Beküldés…',
  'briefs.uploading': 'Feltöltés… {percent}%',
  'briefs.submittedShort': 'Beküldve',
  'briefs.submitted': 'Beküldve review-ra. Hamarosan visszajelzést adunk.',
  'briefs.submitAllFirst': 'Töltsd fel mind a(z) {total} videót a beküldés előtt.',
  'briefs.applyDeadline': 'Jelentkezési határidő',
  'briefs.loadError': 'A briefek betöltése nem sikerult. Próbáld újra.',
  'briefs.applyError': 'A jelentkezés nem sikerult. Próbáld újra.',
  'briefs.submitError': 'A beküldés nem sikerult. Próbáld újra.',

  // Creator-state badges
  'briefs.state.open': 'Nyitott',
  'briefs.state.applied': 'Jelentkeztél',
  'briefs.state.not_selected': 'Nem lettél kiválasztva',
  'briefs.state.confirmed': 'Kiválasztva',
  'briefs.state.in_review': 'Review alatt',
  'briefs.state.approved': 'Jóváhagyva',
  'briefs.state.not_approved': 'Nem lett jóváhagyva',

  // Apply (open) state
  'briefs.apply': 'Jelentkezés a briefre',
  'briefs.applyOpenNote':
    'A jelentkezési határidő ({date}) lezárultáig jelentkezhetsz erre a briefre. A kiválasztott creatorök ezután kapják meg a leadási határidőt és kezdhetik el a videókat.',
  'briefs.slotsNeeded': '{count} creator kell',
  'briefs.applicants': '{count} jelentkező',
  'briefs.spotsTaken': '{taken}/{total} creator kiválasztva',

  // Applied (waiting) state
  'briefs.appliedTitle': 'Jelentkeztél - elbírálás alatt',
  'briefs.appliedBody':
    'Jelentkezésedet rögzítettük. A jelentkezési határidő után értesítünk, ha kiválasztottunk erre a briefre.',

  // Not selected
  'briefs.notSelectedTitle': 'Ezúttal nem választottunk ki',
  'briefs.notSelectedBody':
    'A jelentkezési határidő lezárult, és erre a briefre most más creatoröket választottunk. Nézd meg a többi nyitott briefet - a következő remek lehetőség lehet a tiéd.',

  // Confirmed (selected → start creating)
  'briefs.confirmedTitle': 'Kiválasztottunk - kezdheted a videókat!',
  'briefs.confirmedBody':
    'Gratulálunk, téged választottunk erre a briefre. Készítsd el a videókat a leírás alapján, és töltsd fel őket a leadási határidőig.',

  // ---- Payouts ----
  'payouts.title': 'Kifizetések',
  'payouts.available': 'Elérhető egyenleg',
  'payouts.request': 'Kifizetés igénylése',
  'payouts.requesting': 'Igénylés…',
  'payouts.requested': 'Kifizetési igény elküldve.',
  'payouts.note':
    'A díjazás videónként, teljesítmény alapján - a kifizetés havonta, minden hónap 10-éig.',
  'payouts.earningsTitle': 'Bevétel briefenként',
  'payouts.noEarnings': 'Még nincs bevétel.',
  'payouts.history': 'Kifizetési előzmények',
  'payouts.noPayouts': 'Még nincs kifizetés.',
  'payouts.status.completed': 'Teljesítve',
  'payouts.status.pending': 'Függőben',
  'payouts.loadError': 'A kifizetések betöltése nem sikerult. Próbáld újra.',
  // ---- Dev banner ----
  'dev.bannerFull': 'Fejlesztői mód — az éles verzióhoz látogass el ide: ',
  'dev.bannerShort': 'Fejlesztői mód — ',

};

export default hu;
